import Vue from 'vue'
import VueRouter from 'vue-router'

/* User Page */
import UserLayout from '@/views/homepage/UserLayout.vue'
import Home from '@/views/homepage/Home.vue'
// import DocumentDetail from "@/views/document/DocumentDetail.vue";

/* Admin Page */
import MainLayout from '@/views/admin/MainLayout.vue'
import UserManagement from '@/views/admin/UserManagement.vue'
import AdminSigninDialog from '@/views/admin/AdminSigninDialog.vue'
import Dashboard from '@/views/admin/Dashboard.vue'
import ActiveCode from '@/modules/active-code/ActiveCode.vue'
import Document from '@/modules/cv/admin/Document.vue'
import Grade6ExamResult from '@/modules/cv/admin/Grade6ExamResult.vue'
import Grade10ExamResult from '@/modules/cv/admin/Grade10ExamResult.vue'
import Notification from '@/modules/notification/index.vue'
// import DocumentScholarship from '@/modules/cv/admin/DocumentScholarship/index.vue'
import Document6ExamRetry from '@/modules/cv/admin/Document6ExamRetry/index.vue'

import DocumentG6ExamPrep from '@/modules/cv/admin/DocumentG6ExamPrep/index.vue'
import DocumentG10ExamTrial from '@/modules/cv/admin/DocumentG10ExamTrial/index.vue'
import Transaction from '@/modules/cv/admin/Transaction/index.vue'
import AdsPopupList from '@/modules/cv/admin/AdsPopup/index.vue'

import EventList from '@/views/events/EventList.vue'
import EventDetail from '@/views/events/EventDetail.vue'

import AssignClass from '@/modules/cv/admin/AssignClass/index.vue'
import AssignClass10 from '@/modules/cv/admin/AssignClass10/index.vue'
import DocumentWaitlist from '@/modules/cv/admin/DocumentWaitlist/index.vue'
import EnrollPlan from '@/modules/cv/admin/EnrollPlan/index.vue'
import EnrollConfig10 from '@/modules/cv/admin/EnrollConfig10/index.vue'
import EnrollClass from '@/modules/cv/admin/EnrollClass/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: UserLayout,
    meta: {title: 'Trang chủ'},
    children: [{path: '/', name: 'Home', component: Home, meta: {title: 'Trang chủ'}}],
  },
  {path: '/admin/signin', component: AdminSigninDialog, meta: {title: 'Đăng nhập'}},
  {
    path: '/admin',
    component: MainLayout,
    meta: {title: 'Trang chủ'},
    children: [
      {path: 'dashboard', name: 'Dashboard', component: Dashboard, meta: {title: 'Trang chủ', auth: true}},
      {
        path: 'user',
        name: 'User Management',
        component: UserManagement,
        meta: {title: 'Quản lý tài khoản', auth: true},
      },
      {path: 'active-code', name: 'Active Code', component: ActiveCode, meta: {title: 'Quản lý mã hồ sơ', auth: true}},
      {path: 'document', name: 'Document', component: Document, meta: {title: 'Quản lý hồ sơ', auth: true}},
      {
        path: 'document-g6-exam-prep',
        name: 'HS K6 HDPPLB',
        component: DocumentG6ExamPrep,
        meta: {title: 'HS K6 HDPPLB', auth: true},
      },
      {
        path: 'document-g10-exam-trial',
        name: 'HS K10 thi thử',
        component: DocumentG10ExamTrial,
        meta: {title: 'HS K10 thi thử', auth: true},
      },
      {path: 'transactions', name: 'Quản lý thu', component: Transaction, meta: {title: 'Quản lý thu', auth: true}},
      {
        path: 'enroll-plan',
        name: 'Kế hoạch nhập học',
        component: EnrollPlan,
        meta: {title: 'Quản lý Kế hoạch nhập học', auth: true},
      },
      {
        path: 'assign-class',
        name: 'Quản lý xếp lớp - Khối 6',
        component: AssignClass,
        meta: {title: 'Quản lý xếp lớp - Khối 6', auth: true},
      },
      {
        path: 'assign-class-10',
        name: 'Quản lý xếp lớp - Khối 10',
        component: AssignClass10,
        meta: {title: 'Quản lý xếp lớp - Khối 10', auth: true},
      },
      {
        path: 'cv-waitlist',
        name: 'Quản lý DS ĐK chờ',
        component: DocumentWaitlist,
        meta: {title: 'Quản lý DS ĐK chờ', auth: true},
      },
      {
        path: 'document-retry-1',
        name: 'Document 6 Retry',
        component: Document6ExamRetry,
        meta: {title: 'Hồ sơ đăng thi đợt 2 khối 6', auth: true},
      },
      {
        path: 'grade6-result',
        name: 'Grade6ExamResult',
        component: Grade6ExamResult,
        meta: {title: 'Kết quả thi Khối 6', auth: true},
      },
      {
        path: 'grade10-result',
        name: 'Grade10ExamResult',
        component: Grade10ExamResult,
        meta: {title: 'Kết quả thi Khối 10', auth: true},
      },
      {
        path: 'notification',
        name: 'Notification',
        component: Notification,
        meta: {title: 'Gửi thông báo', auth: true},
      },
      {
        path: 'ads-popups',
        name: 'Ads Popups',
        component: AdsPopupList,
        meta: {title: 'Quản lý popup động', auth: true},
      },
      {
        path: 'events',
        component: EventList,
        name: 'EventList',
        meta: {title: 'Danh sách sự kiện', auth: true},
      },
      {
        path: 'events/:id',
        component: EventDetail,
        name: 'EventDetail',
        meta: {title: 'Chi tiết sự kiện', auth: true},
      },
      {
        path: 'enroll-config-10',
        component: EnrollConfig10,
        name: 'EnrollConfig10',
        meta: {title: 'Cấu hình nhập học K10', auth: true},
      },
      {
        path: 'enroll-class',
        component: EnrollClass,
        name: 'EnrollClass',
        meta: {title: 'QL danh sách lớp', auth: true},
      },
    ],
  },
]

const router = new VueRouter({routes, mode: 'history'})

export default router
